import Shepherd from 'shepherd.js'
import { getUserData, getUserRole } from '@/auth/utils'

function tourKey() {
  const user = getUserData()
  const id = user ? user.id : 'guest'
  return `demo_tour_completed_${id}`
}

const TOUR_TTL_DAYS = 30

export function hasTourBeenSeen() {
  const stored = localStorage.getItem(tourKey())
  if (!stored) return false
  const seenAt = parseInt(stored, 10)
  const elapsed = Date.now() - seenAt
  return elapsed < TOUR_TTL_DAYS * 24 * 60 * 60 * 1000
}

export function markTourSeen() {
  localStorage.setItem(tourKey(), Date.now().toString())
}

function buildButtons(tour, isFirst, isLast) {
  const buttons = []

  if (!isLast) {
    buttons.push({
      text: 'Saltar tour',
      classes: 'shepherd-btn-skip',
      action() { tour.cancel() },
    })
  }

  if (!isFirst) {
    buttons.push({
      text: '← Anterior',
      classes: 'shepherd-btn-secondary',
      action() { tour.back() },
    })
  }

  if (!isLast) {
    buttons.push({
      text: 'Siguiente →',
      classes: 'shepherd-btn-primary',
      action() { tour.next() },
    })
  } else {
    buttons.push({
      text: '¡Finalizar!',
      classes: 'shepherd-btn-primary',
      action() {
        // eslint-disable-next-line no-console
        console.log('[Tour] CTA: ¿Quieres Shireo en tu empresa?')
        tour.complete()
      },
    })
  }

  return buttons
}

const ADMIN_STEPS = [
  {
    id: 'welcome',
    title: '👋 ¡Bienvenido a Shireo!',
    text: 'Te guiaremos por las funciones principales. Solo tardará un momento.',
  },
  {
    id: 'fichar',
    title: '⏱️ Fichar',
    text: 'Aquí registras la entrada y salida de los trabajadores. Consulta el estado de cada jornada en tiempo real.',
    attachTo: { element: 'a[href="/admin/fichar"]', on: 'right' },
  },
  {
    id: 'partes',
    title: '📊 Parte de horas',
    text: 'Historial completo de fichajes de todo el equipo: entradas, salidas e incidencias.',
    attachTo: { element: 'a[href="/admin/partes"]', on: 'right' },
  },
  {
    id: 'usuarios',
    title: '👥 Usuarios',
    text: 'Gestiona tu equipo: añade empleados, asigna departamentos y controla los accesos.',
    attachTo: { element: 'a[href="/admin/users"]', on: 'right' },
  },
  {
    id: 'cta',
    title: '✅ ¡Eso es todo!',
    text: '¿Quieres Shireo en tu empresa? Contacta con nosotros y te lo explicamos todo.',
  },
]

const OPERARIO_STEPS = [
  {
    id: 'welcome',
    title: '👋 ¡Bienvenido a Shireo!',
    text: 'Te guiaremos por las funciones disponibles. Solo tardará un momento.',
  },
  {
    id: 'fichar',
    title: '⏱️ Fichar',
    text: 'Aquí registras tu entrada y salida. También puedes consultar el resumen de tu jornada.',
    attachTo: { element: 'a[href="/admin/fichar"]', on: 'right' },
  },
  {
    id: 'partes',
    title: '📊 Parte de horas',
    text: 'Consulta tu historial de horas trabajadas, entradas y salidas.',
    attachTo: { element: 'a[href="/admin/partes"]', on: 'right' },
  },
  {
    id: 'cta',
    title: '✅ ¡Listo!',
    text: '¿Tu empresa aún no usa Shireo? Díselo y empieza a controlar tu jornada de forma profesional.',
  },
]

export function startTour() {
  localStorage.removeItem(TOUR_KEY)
  const tour = createTour()
  tour.start()
}

export function createTour() {
  const role = getUserRole()
  const steps = role === 'operario' ? OPERARIO_STEPS : ADMIN_STEPS

  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      classes: 'shireo-tour-step',
      scrollTo: false,
      cancelIcon: { enabled: false },
      modalOverlayOpeningPadding: 6,
      modalOverlayOpeningRadius: 4,
    },
  })

  steps.forEach((step, index) => {
    tour.addStep({
      ...step,
      buttons: buildButtons(tour, index === 0, index === steps.length - 1),
    })
  })

  tour.on('cancel', markTourSeen)
  tour.on('complete', markTourSeen)

  return tour
}
